import React from 'react';
import { useWatch } from 'react-hook-form';
import { Box, Typography } from '@mui/material';
import { CTableWrapper } from '../../../../../../dum';
import { useExpenseSupplierCatalogReferenceQuery } from '../../../../../../../services';
import { formatFloat } from '../../../../../../../helpers';
import { ACCOUNT, IExpense } from '../expense-form';

// Read-only reference of the selected supplier's resource catalog, shown under
// the editable expense resources table. It never writes into the form — it's
// purely informative so the user can match the guideline price without leaving
// the expense dialog. Renders nothing until a supplier is picked and only when
// that supplier actually has a catalog.
export function ExpenseSupplierCatalogReference() {
    const account = useWatch({ name: ACCOUNT }) as IExpense['account'];
    const accountId = account?.id || null;

    const { data } = useExpenseSupplierCatalogReferenceQuery({
        skip: !accountId,
        variables: {
            AccountId: accountId!,
        },
    });

    const resourceCatalog = data?.getAccountResources ?? [];

    if (!accountId || resourceCatalog.length === 0) return null;

    return (
        <Box sx={{ mt: 1, mb: 3 }}>
            <Typography variant={'subtitle2'} sx={{ mx: 1, mb: 1 }}>
                Recursos del catálogo del proveedor
            </Typography>
            <CTableWrapper
                data={resourceCatalog}
                items={[
                    {
                        title: 'Recurso',
                        cellGrow: 55,
                        content: (ar) => ar.resource?.name ?? '',
                    },
                    {
                        title: '$ unitario',
                        textAlign: 'right',
                        cellGrow: 15,
                        content: (ar) => formatFloat(ar.unit_price),
                    },
                    {
                        title: 'Notas',
                        textAlign: 'left',
                        cellGrow: 30,
                        content: (ar) => ar.notes ?? '',
                    },
                ]}
            />
        </Box>
    );
}
